
import Vue from "vue";
import { ISong } from "../@types/interface.d";

interface DataType {
  candidateSongs: ISong[];
  selectedSongs: number[];
  all: boolean;
}

export default Vue.extend({
  name: "SelectSongs",
  props: ["title", "songs", "selected"],
  data(): DataType {
    return {
      candidateSongs: this.songs,
      selectedSongs: this.selected,
      all: false,
    };
  },
  methods: {
    onChange(n: number) {
      let newSongs: number[];
      if (this.selectedSongs.indexOf(n) !== -1) {
        newSongs = this.selectedSongs.filter(v => v !== n);
      } else {
        newSongs = this.selectedSongs.concat([n]);
      }
      this.selectedSongs = newSongs;
    },
    onAll() {
      this.all = !this.all;
      if (this.all) {
        this.selectedSongs = this.candidateSongs.map(v => v.id);
      } else {
        this.selectedSongs = [];
      }
    },
    isSelected(song: ISong): boolean {
      return Boolean(this.selectedSongs.find(v => v === song.id));
    },
    next() {
      if (this.selectedSongs.length === 0) {
        return;
      }
      this.$emit("next", this.selectedSongs);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
});

